
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';

@Injectable()

export class AppInitializerService {

    constructor(private appConfigService: AppConfigService) { }

    /**
     * This method is called at the start of the application to load the app config
     * @returns {Promise<void>} - A promise that resolves when the app config is loaded
     */


    initializeApp(): Promise<void> {
        return new Promise((resolve, reject) => {
           // console.log("AppInitializerService :: calling LoadAppConfig");

            this.appConfigService.LoadAppConfig().subscribe({
                next: () => {
                  //  console.log("AppInitializerService :: LoadAppConfig.next");
                    resolve();
                },
                error: (err) => {
                   // console.error("AppInitializerService :: LoadAppConfig.error", err);
                    reject(err);
                },
                complete: () => {
                  //  console.log("AppInitializerService :: LoadAppConfig.complete");
                },
            });
        });
    }

}